import { render, staticRenderFns } from "./FrontendScripts.vue?vue&type=template&id=8d124f68&scoped=true&"
import script from "./FrontendScripts.vue?vue&type=script&lang=ts&"
export * from "./FrontendScripts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d124f68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d124f68')) {
      api.createRecord('8d124f68', component.options)
    } else {
      api.reload('8d124f68', component.options)
    }
    module.hot.accept("./FrontendScripts.vue?vue&type=template&id=8d124f68&scoped=true&", function () {
      api.rerender('8d124f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FrontendScripts.vue"
export default component.exports